/**
 * all actions for portfolio state
 *
 * Created by Tom on 16/06/18
 */

import C from '../constants'


// action to hide/show the loader for the portfolio
export const showPortfolioLoader = booleanVal => {
    return {
        type: C.SET_PORTFOLIO_LOADER,
        payload: booleanVal
    }
}

// action to set the portfolio data
export const setPortfolioData = objectVal => {
    return {
        type: C.SET_PORTFOLIO_DATA,
        payload: objectVal
    }
}

/* -----------------------------------------------------------------------------
    ACTIONS CREATORS
----------------------------------------------------------------------------- */



// WEBPACK FOOTER //
// ./src/actions/portfolioActions.js